import { Input, Select } from "antd";
import { FormEventHandler, useEffect, useState } from "react";
import { Control, useController } from "react-hook-form";
import { useGetAllNotaFiscal } from "../../../NotasFiscais/hooks/useGetNotasFiscais";
import { IconSearch } from "../../../../shared/Icons/IconSearch";
import { tipoMovimentoData } from "../../util/tipoMovimentoData";

interface FiltroAvancadoType {
  onSubmit?: FormEventHandler | undefined;
  control: Control<any>;
  onClick?: any;
  width?: string;
}

interface NFOption {
  value: string;
  label: string
}

export function FiltroAvancado({
  onSubmit,
  control,
  onClick,
  width,
}: FiltroAvancadoType) {
  const [nfOptions, setNfOptions] = useState<NFOption[]>([]);
  const { field } = useController({ control, name: "search" })

  const { data: notaFiscalData, isLoading } = useGetAllNotaFiscal();

  useEffect(() => {
    if (notaFiscalData) {
      const options = notaFiscalData.map((nfe: any) => ({
        value: nfe.Numero.toString(),
        label: nfe.Numero.toString(),
      }));
      setNfOptions(options);
    }
  }, [notaFiscalData]);

  return (
    <form onSubmit={onSubmit} className="flex gap-2">
      {tipoMovimentoData &&
        <SelectFilter
          dataSource={tipoMovimentoData}
          placeholder={!isLoading ? 'Tipo Movimento' : 'Carregando...'}
          disabled={isLoading}
          dataName="movimentoTipo"
          control={control}
          width={148}
        />
      }

      <SelectFilter
        dataSource={nfOptions}
        placeholder={!isLoading ? 'Nota Fiscal' : 'Carregando...'}
        disabled={isLoading}
        dataName="numeroNF"
        control={control}
        width={130}
      />

      <div className="flex gap-0">
          <Input
            {...field}
            className={`border-solid border-[1px] flex flex-row ${width ? width : 'w-[25rem]'} 
            h-10 justify-between items-center px-2 border-gray-300 rounded-l-md focus:outline-none`}
            placeholder="Pesquisar..."
            allowClear
            onKeyPress={function (e) {
              if (e.key === "Enter") {
                onClick()
              }
            }}
          />
        <button
          onClick={onClick}
          type="submit"
          className="h-10 w-[3rem] rounded-r-md focus:outline-none border-solid border-[1px] flex items-center justify-center hover:bg-gray-50">
          <IconSearch color="#858E96" />
        </button>
      </div>
    </form>
  );
}

interface SelectType {
  dataSource: any[];
  placeholder: string;
  control: Control<any>;
  dataName: string;
  disabled?: boolean;
  width?: number;
}

function SelectFilter({ dataSource, placeholder, control, dataName, disabled, width }: SelectType) {
  const { field } = useController({ control, name: dataName })

  return (
    <>
      <Select
        options={dataSource}
        disabled={disabled}
        {...field}
        style={{ width: width }}
        placeholder={placeholder}
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label ?? '').includes(input)}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        }
        showSearch
        allowClear
      />
    </>
  );
}
